import { render } from "./component_footer.vue?vue&type=template&id=1ac4baba&scoped=true"
import script from "./component_footer.vue?vue&type=script&lang=js"
export * from "./component_footer.vue?vue&type=script&lang=js"

import "./component_footer.vue?vue&type=style&index=0&id=1ac4baba&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac4baba"]])

export default __exports__